import ConfigPage from "../views/UserConfigurationView";
import { Route, Routes, Navigate } from "react-router-dom";
import UploadedFileGrid from "../views/UploadedFileGrid";
import ChatAssistantView from "../views/ChatAssistantView";
import { Box } from "@mantine/core";
import SessionSidebar, { SIDEBAR_WIDTH, SIDEBAR_COLLAPSED_WIDTH } from "../components/sidebar/SessionSidebar";
import { SessionProvider } from "../contexts/SessionContext";
import UsersView from "../views/UsersView";
import CollectionsView from "../views/CollectionsView";
import FolderExplorerPage from "../views/FolderExplorerPage";
import BackgroundJobsGuard from "../guards/BackgroundJobsGuard";
import DashboardView from "../views/BackgroundJobsView";
import AccessDeniedPage from "../components/AccessDenied";
import { useState, useEffect } from "react";
import DocumentContentEditorView from "../views/DocumentContentEditorView";

const AuthenticatedApp = ({ userEmail }: { userEmail: string | null }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  useEffect(() => {
    const handleSidebarToggle = (event: any) => {
      setSidebarCollapsed(event.detail.collapsed);
    };

    // Check initial state from localStorage
    const initialState = localStorage.getItem('sidebarCollapsed') === 'true';
    setSidebarCollapsed(initialState);

    window.addEventListener('sidebarToggle', handleSidebarToggle);
    return () => {
      window.removeEventListener('sidebarToggle', handleSidebarToggle);
    };
  }, []);

  const currentSidebarWidth = sidebarCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH;

  return (
    <SessionProvider>
      <div className='authenticated-container'>
        <Box style={{ display: 'flex' }}>
          <SessionSidebar userEmail={userEmail} />

          <Box
            className="authenticated-content-container"
            style={{
              marginLeft: `${currentSidebarWidth}px`,
              width: `calc(100% - ${currentSidebarWidth}px)`,
              minHeight: '100vh',
              paddingTop: 0,
              boxSizing: 'border-box',
              flex: 1,
              overflowX: 'hidden',
              transition: 'margin-left 0.3s ease, width 0.3s ease',
            }}
          >
            <Box style={{ maxWidth: '100%', margin: '0 auto', width: '100%' }}>
              <Routes>
                <Route path="/user-configuration" element={<ConfigPage />} />
                <Route path="/uploaded-files" element={<UploadedFileGrid />} />
                <Route path="/users" element={<UsersView />} />
                <Route path="/documents/:uploadedFileId/content" element={<DocumentContentEditorView />} />
                <Route path="/assistant/chat" element={<ChatAssistantView />} />
                <Route path="/collections" element={<CollectionsView />} />
                <Route path="/folder-explorer" element={<FolderExplorerPage />} />
                <Route path="/logs" element={
                  <BackgroundJobsGuard>
                    <DashboardView endpoint="logs" />
                  </BackgroundJobsGuard>
                } />
                <Route path="/access-denied" element={<AccessDeniedPage />} />
                <Route
                  path="/background-jobs"
                  element={
                    <BackgroundJobsGuard>
                      <DashboardView endpoint="api/background-jobs" />
                    </BackgroundJobsGuard>
                  }
                />
                <Route path="*" element={<Navigate to="/assistant/chat" replace />} />
              </Routes>
            </Box>
          </Box>
        </Box>
      </div>
    </SessionProvider>
  );
};


export default AuthenticatedApp;
